module.exports = __webpack_public_path__ + "static/img/LACQUERED-PVC-PARIS.dc5dae2.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/LACQUERED-PVC-PARIS.png
// module id = VfMy
// module chunks = 0